import { NgOptimizedImage } from '@angular/common';
import { Component, Input, input } from '@angular/core';

@Component({
  selector: 'ibero-header',
  imports: [NgOptimizedImage],
  templateUrl: './header.html',
  styleUrl: './header.css'
})
export class Header {

  public gslogo!: string ;
  public gscolor!: string ;

  ngOnInit() {
    this.gslogo = localStorage.getItem('gslogo') || '';
    this.gscolor = localStorage.getItem('gscolor') || '';
  }

}
